// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-sSnj","colBig":"styles_colBig__3TQHQ","colSmall":"styles_colSmall__3yiNB"};